<template>
  <div class="login-container">
    <TopBar
      color="#000"
      :login="true"
      signUp="#0D53FF"
      loginColor="#A3AAB7"
      :imgsrc="logo1"
    />
    <div class="login-img"></div>
    <div class="login-content">
      <div class="content-input-box">
        <div class="title"><span>Hello!</span><span>欢迎登录</span></div>
        <div class="input-list">
          <div class="input-list-item">
            <img :src="phone" alt="" />
            <input type="text" placeholder="请输入手机号" v-model="username" />
          </div>
          <div class="input-list-item">
            <img :src="password" alt="" />
            <input
              type="password"
              placeholder="请输入登录密码"
              v-model="passWord"
            />
          </div>
        </div>
        <div class="checkBox">
          <input type="checkbox" id="CheckBox" v-model="istrue" />
          <label for="CheckBox">记住登录状态</label>
        </div>

        <div class="btn-submit" @click="handlelogin">登录</div>
        <div class="routerpush">
          <div class="signup">
            <p>没有账号?立即</p>
            <span @click="SignUp">注册</span>
          </div>
          <div class="setpassword">忘记密码</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import phone from "@/assets1/登录_slices/删除备份 3@3x.png";
import password from "@/assets1/登录_slices/删除备份@3x.png";
import TopBar from "@/views/supermarket/TopBar";
import logo1 from "@/assets1/logo_slices/编组 2.png";
import { Login } from "@/api/user";
export default {
  components: {
    TopBar,
  },
  data() {
    //   const res=await Login({
    //       login_type: 2,
    //       username: "Alex3",
    //       password: "654321"
    // })
    return {
      logo1,
      phone,
      password,
      username: "",
      passWord: "",
      istrue: false,
    };
  },
  methods: {
    SignUp(){
      this.$router.push('/SignUp')
    },
    async handlelogin() {
     try{
      const res = await Login({
        login_type: 1,
        phone: this.username,
        password: this.passWord,
      });
      if(res.user.username===''||res.user.company_name===''){
        Message({
        message: "请先完善个人信息",
        type: "warning",
      });
      this.$router.push('/informationCompletion')
      }
      else{
        Message({
        message: "登录成功",
        type: "success",
      });
      this.$router.push("/dataset");
      }
  

      this.$store.commit("setUid", res.user_id);
      this.$store.commit("setUserInfo", res.user);
      if (this.istrue) {
        localStorage.setItem("token", `Bearer ${res.access_token}`);
      } else {
        sessionStorage.setItem("token", `Bearer ${res.access_token}`);
      }
     }catch(error){
     console.log(error,'error');
     if(error.response.status===403){
      Message({
        message: "用户名或密码错误",
        type: "error",
      });
     }
     }

    },
  },
};
</script>

<style scoped>
.setpassword {
  font-family: Regular;
  color: #3d79ec;
}
.signup {
  display: flex;
  font-family: Regular;
}
.signup span {
  font-family: Regular;
  color: #3d79ec;
}
.routerpush {
  margin-top: 5px;
  font-size: 12px;
  display: flex;
  color: #999;
  width: 100%;
  justify-content: space-between;
}
.btn-submit {
  margin-top: 41px;
  width: 350px;
  height: 45px;
  background-color: #0d53ff;
  border-radius: 4px;
  font-size: 16px;
  color: white;
  text-align: center;
  line-height: 45px;
  cursor: pointer;
}
.checkBox label {
  font-size: 12px;
  color: #666;
}
.checkBox input {
  margin-right: 8px;
}
.checkBox {
  display: flex;
  height: 16px;
  line-height: 16px;
}
.content-input-box {
  width: 350px;
}
.input-list-item input {
  outline: none;
  border: none;
  height: 20px;
  padding-left: 16px;
  font-size: 14px;
  width: 85%;
}
.input-list-item img {
  width: 20px;
  object-fit: cover;
  height: 20px;
}
.input-list-item {
  padding-bottom: 10px;
  width: 350px;
  border-bottom: 1px solid #d6dae2;
  display: flex;
  margin-bottom: 30px;
}
.title {
  margin-bottom: 100px;
  text-align: center;
}
.login-content {
  display: flex;

  justify-content: center;
  align-items: center;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0.6px;
}
.login-content span:first-child {
  display: inline-block;
  width: 107px;
}
.login-content span {
  font-family: Medium;
}
.login-container {
  min-width: 100%;
  height: 100vh;
  display: flex;
  font-family: Regular;
  flex-shrink: 0;
}
.login-img {
  flex-shrink: 0;
  width: 38%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: url("https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E7%99%BB%E5%BD%95%E9%A1%B5/Group%208.png");
}
.login-content {
  flex-shrink: 0;
  width: 62%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 响应式设计 */
@media screen and (max-width: 1200px) {
  .login-img {
    width: 35%;
  }
  .login-content {
    width: 65%;
  }
}

@media screen and (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }
  .login-img {
    width: 100%;
    height: 30vh;
    background-size: cover;
  }
  .login-content {
    width: 100%;
    height: 70vh;
    padding: 20px;
  }
  .content-input-box {
    width: 100%;
    max-width: 400px;
  }
  .btn-submit {
    width: 100%;
    max-width: 350px;
  }
  .input-list-item {
    width: 100%;
    max-width: 350px;
  }
}

@media screen and (max-width: 480px) {
  .login-img {
    height: 25vh;
  }
  .login-content {
    height: 75vh;
    padding: 15px;
  }
  .title {
    margin-bottom: 50px;
    font-size: 24px;
  }
  .login-content {
    font-size: 24px;
  }
}
</style>
